import { SET_AUDIT, CLEAR_AUDIT } from '../actions/actionTypes';
import { arrToObj } from '@/redux/util';

const preState = {};

const auditReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, audit } = action;
	switch (type) {
		case SET_AUDIT:
			const auditNodes = audit && audit.nodes ? audit.nodes : [];
			return arrToObj(auditNodes);
		case CLEAR_AUDIT:
			return {};
		default:
			return stateDup;
	}
};

export default auditReducer;
